import { injectable } from "inversify";
import MasterItemEntity from "../../../domain/entities/master_item.entity";
import MasterDataRepository from "../../../domain/repositories/master_data.repository";
import getCallTypesApiImpl from "./api/get_call_types.api.impl";

@injectable()
class MasterDataRepositoryDev implements MasterDataRepository {
    getCallTypes = (): Promise<MasterItemEntity[]> => getCallTypesApiImpl();
}

export default MasterDataRepositoryDev;